import React, { useState } from 'react';
import {Link} from "react-router-dom";
import Popup from "../../../components/Popup";
import mailImage from '../../../assets/icons/mail.svg';
import {useTranslation} from "react-i18next";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import useForm from "../../../hooks/useForm";
import {RequestPasswordReset} from "../../../api/users/requestPasswordReset";
import {LoadingIcon} from "../../../assets/icons/Icons";
import FormErrorsOutput from "../../../components/form/FormErrorsOutput";
import Message from "../../../components/Message";

function Index(props) {
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);

    const onSuccess = () => {
        setSuccess(true);
    }

    const {loading, error, fieldErrors, handleSubmit } = useForm(onSuccess);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit(RequestPasswordReset, {email});
    };

    return (
        <Popup>
            <div style={{display: "flex", justifyContent: 'flex-end'}}>
                <LanguageSwitcher/>
            </div>
            <div className="pl-3 pr-3">
                <div className="mt-3 mb-3">
                    <h1 className="mb-1">{t("Forgot Password?")}</h1>
                    <p>{t("Enter your email address below and we'll send you a link to log in and reset your password.")}</p>
                </div>
                <form action="" method="post" className="mb-2">
                    <div className="row mb-1">
                        <div className="col-xs-12">
                            <label htmlFor="email">{t("Email")}</label>
                            <div className="input-wrapper input-with-icon input-with-icon-left">
                                <input type="email" placeholder="john@example.com" name="email" value={email} onChange={e => {setEmail(e.target.value)}}/>
                                <div className="input-icon input-icon-left">
                                    <img
                                        title="email"
                                        src={mailImage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="input-wrapper">
                                <button disabled={!email} className={`btn btn-primary ${loading ? 'btn-loading' : ''}`} style={{width: '100%'}} type="submit"
                                        name="submit"  onClick={handleFormSubmit}>
                                    {loading ? <LoadingIcon/> : ""}
                                    {t("Send a link")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <FormErrorsOutput error={error} fieldErrors={fieldErrors} className="mt-2 mb-2"/>

                    {success && <Message showIcon className="mb-2 mt-2" type="message-success" message={<><p>{t("You have been successfully requested password reset!")}</p></>}/>}

                </form>
                <hr className="mt-3 mb-3"/>
                <div className="row">
                    <div className="col-xs-8">
                        <Link to="#" className="small-text">{t("Remember your password?")}</Link>
                    </div>
                    <div className="col-xs-4">
                        <Link to="/user/login" style={{fontWeight: '700'}}>{t("Back to login")}</Link>
                    </div>
                </div>
            </div>
        </Popup>
    );
}

export default Index;